import { RowPreviewPanel } from '~/components/rowPreview/RowPreviewPanel';
import type { RowPreview } from '~/components/rowPreview/useRowPreview';
import { RowPreviewSuppressedContext } from '~/components/rowPreview/useTableRowPreview';
import { TaskDetailView } from '~/components/tasks/detail/TaskDetailView';
import type { TaskDetail } from '~/data/generated/model';

export function TaskPreviewPanel({
  rowPreview,
  onOpenFullPage,
  onCompleted,
}: {
  rowPreview: RowPreview;
  onOpenFullPage: (taskId: string) => void;
  onCompleted: (task: TaskDetail) => void;
}) {
  return (
    <RowPreviewPanel
      rowPreview={rowPreview}
      ariaLabel="Task preview"
      onOpenFullPage={onOpenFullPage}
    >
      {(taskId) => (
        // One panel at a time: the task's own tables don't open a second one.
        <RowPreviewSuppressedContext.Provider value>
          <TaskDetailView
            key={taskId}
            taskId={taskId}
            variant="preview"
            onCompleted={onCompleted}
          />
        </RowPreviewSuppressedContext.Provider>
      )}
    </RowPreviewPanel>
  );
}
